import type { AppUser, AdminUserStatus } from '@/hooks/useUsuarios';

export const ADMIN_USER_ROLES = [
  'PRESIDENCIA',
  'DIRETORIA',
  'FINANCEIRO',
  'HOMOLOGACAO',
  'COLONIAL',
  'JURIDICO',
] as const;

export const ADMIN_USER_STATUS_ORDER: AdminUserStatus[] = [
  'APPROVED',
  'PENDING',
  'REJECTED',
  'INACTIVE',
];

export const ADMIN_USER_STATUS_META: Record<
  AdminUserStatus,
  {
    label: string;
    tone: string;
    subtleTone: string;
    description: string;
  }
> = {
  APPROVED: {
    label: 'Aprovado',
    tone: 'border-emerald-200 bg-emerald-50 text-emerald-700',
    subtleTone: 'bg-emerald-50 text-emerald-700',
    description: 'Pode acessar o sistema normalmente.',
  },
  PENDING: {
    label: 'Pendente',
    tone: 'border-amber-200 bg-amber-50 text-amber-700',
    subtleTone: 'bg-amber-50 text-amber-700',
    description: 'Aguardando aprovação administrativa.',
  },
  REJECTED: {
    label: 'Rejeitado',
    tone: 'border-rose-200 bg-rose-50 text-rose-700',
    subtleTone: 'bg-rose-50 text-rose-700',
    description: 'Acesso negado até nova revisão.',
  },
  INACTIVE: {
    label: 'Inativo',
    tone: 'border-slate-200 bg-slate-100 text-slate-700',
    subtleTone: 'bg-slate-100 text-slate-700',
    description: 'Conta bloqueada manualmente pela administração.',
  },
};

export const getUserDisplayName = (user: Pick<AppUser, 'email' | 'profile_name' | 'user_metadata'>) => {
  const name = user.profile_name || user.user_metadata?.full_name || user.user_metadata?.name;
  return name || user.email?.split('@')[0] || 'Usuário';
};

export const getUserInitials = (name: string = '') =>
  name
    .split(' ')
    .filter(Boolean)
    .map((part) => part[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();

export const getRoleLabel = (role?: string | null) => {
  if (!role) return 'Sem papel';

  const labels: Record<string, string> = {
    PRESIDENCIA: 'Presidência',
    DIRETORIA: 'Diretoria',
    FINANCEIRO: 'Financeiro',
    HOMOLOGACAO: 'Homologação',
    COLONIAL: 'Colonial',
    JURIDICO: 'Jurídico',
  };

  return labels[role] || role;
};

export const formatUserDate = (value?: string | null, options?: Intl.DateTimeFormatOptions) => {
  if (!value) return 'Não disponível';

  try {
    return new Intl.DateTimeFormat('pt-BR', options).format(new Date(value));
  } catch {
    return 'Não disponível';
  }
};
